import { render, staticRenderFns } from "./BaseTostDanger.vue?vue&type=template&id=eba5cdec&"
import script from "./BaseTostDanger.vue?vue&type=script&lang=js&"
export * from "./BaseTostDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports